export const initRemoveChecked = () => {
  const financeInputFalse = document.getElementById(
    "inspection_request_finance_false"
  );
  if (financeInputFalse) financeInputFalse.checked = false;
  const transportInputFalse = document.getElementById(
    "inspection_request_transport_false"
  );
  if (transportInputFalse) transportInputFalse.checked = false;
};
